import 'vuetify/styles'
import { type ThemeDefinition, createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import { aliases, fa } from 'vuetify/iconsets/fa'
import { pt } from 'vuetify/locale'

import '@awesome.me/kit-d61a0973ab/icons/css/all.css'

// WARN: remove after: https://github.com/vuetifyjs/vuetify/issues/18725 gets merged
import { VDateInput } from 'vuetify/labs/components'

const lightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#eee',
    surface: '#FFFFFF',
    primary: '#EA8300',
    secondary: '#494949',
    error: '#B00020',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
    tertiary: '#83CC6F',
    heading: '#fff',
    body: '#D4D4D4',
  },
}

export const vuetify = createVuetify({
  theme: {
    defaultTheme: 'lightTheme',
    themes: {
      lightTheme,
    },
  },
  icons: {
    defaultSet: 'fa',
    aliases,
    sets: {
      fa,
    },
  },
  components: {
    VDateInput,
    ...components,
  },
  directives,
  locale: {
    locale: 'pt',
    messages: { pt },
  },
})
